import { render } from "./SearchResultLayout.vue?vue&type=template&id=cdf3f3e6&scoped=true"
import script from "./SearchResultLayout.vue?vue&type=script&lang=js"
export * from "./SearchResultLayout.vue?vue&type=script&lang=js"

import "./SearchResultLayout.vue?vue&type=style&index=0&id=cdf3f3e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf3f3e6"]])

export default __exports__